import loader from '../../assets/images/loader.gif';
export default function Loader() {
    return (
      <div className="loader-overlay">
        <div className="loader console_loader">
          <div className="loader-spinner"></div>
        </div>
      </div>
    );
}